import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";
import { IZipZone } from "../Utils/Interface";
import "./StepsNavigation.css";

type Props = {
	partner: IZipZone;
};

type State = {};

@observer
class SalesPartnerItem extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {};
	}

	render() {
		const partner = this.props.partner;
		return (
			<div className="sales-partner-item">
				<h2>{generalConfigurationStore.configs?.salesPartnerResultHeadline}</h2>
				<h3>{partner.title}</h3>
				<p>{partner.content?.replace(/<\s*\w*\s*href\s*=\s*"?\s*([\w\s%#/.;:_-]*)\s*"?.*?>/g, "").replace(/<\/?.+?>/gi, "")}</p>
			</div>
		);
	}
}

export default SalesPartnerItem;
